import qs from 'qs';

export const state = () => ({
	filtered_company_jobs: null,
	dropdown_jobs: null,
	selected_job: {},

	filters: null,
	candidate_filter: null,
	order: {
		order_by: 'created_at',
		order_dir: 'desc',
	},
	search: null,
	expired_jobs: []
});
export const mutations = {
	setFilteredCompanyJobs(state: any, payload: any) {
		state.filtered_company_jobs = payload;
	},
	setExpiredJobs(state: any, payload: any) {
		state.expired_jobs = payload;
	},
	setDropdownJobs(state: any, payload: any) {
		state.dropdown_jobs = payload;
	},
	setSelectedJob(state: any, payload: any) {
		state.selected_job = payload;
	},
	setFilters(state: any, payload: any) {
		state.filters = payload;
	},
	setCandidateFilter(state: any, payload: any) {
		state.candidate_filter = payload;
	},
	setOrder(state: any, payload: any) {
		state.order = payload;
	},
	setSearch(state: any, payload: any) {
		state.search = payload;
	},
};
export const getters = {
	getFilteredCompanyJobs: (state: any) => state.filtered_company_jobs,
	getExpiredJobs: (state: any) => state.expired_jobs,
	getDropdownJobs: (state: any) => state.dropdown_jobs,
	getSelectedJob: (state: any) => state.selected_job,
	getFilters: (state: any) => state.filters,
	getOrder: (state: any) => state.order,
	getSearch: (state: any) => state.search,
};
export const actions = {
	getFilteredCompanyJobs(state: any, payload: any) {
		let url = payload?.url || '/api/company/' + state.rootState.auth.user.company.uuid + '/filter-jobs';

		let data = {
			...state.state.filters,
			...state.state.order,
			search: state.state.search,
		};

		if (state.state.candidate_filter) {
			data = JSON.parse(JSON.stringify(data));

			data.filters ? data.filters.push(state.state.candidate_filter) : (data.filters = [state.state.candidate_filter]);
		}

		if (!state.state.search) {
			delete data.search;
		}

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, {
					params: { ...data },
					paramsSerializer: (params) => {
						return qs.stringify(params, { arrayFormat: 'indices' });
					},
				})
				.then((res) => {
					state.commit('setFilteredCompanyJobs', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getCompanyExpiredJobs(state: any, payload: any) {
		const company_uuid = state.rootState.auth.user.company.uuid;


		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/company/${company_uuid}/expired-jobs`)
				.then((res) => {
					state.commit('setExpiredJobs', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	answerJobHired(state: any, payload: any){
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/jobs/${payload.uuid}/job-hired`, {
					hired: payload.hired,
					candidate_uuid: payload.candidate_uuid
				})
				.then((res) => {
					let arr = [...state.state.expired_jobs];
					let index = arr.findIndex((val) => val.uuid === payload.uuid);
					if(index > -1){
						arr.splice(index, 1)
					}
					state.commit('setExpiredJobs', arr);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getDropdownJobs(state: any, payload: any) {
		const company_uuid = state.rootState.auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/dropdowns/company/${company_uuid}/jobs`, { params: payload })
				.then((res) => {
					state.commit('setDropdownJobs', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	inviteToJob(state: any, payload: any) {
		const { job_uuid, ...data } = payload;

		// Delete empty keys from the posted data
		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/jobs/${job_uuid}/invites`, data)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setFilteredCompanyJobs(state: any, payload: any) {
		state.commit('setFilteredCompanyJobs', payload);
	},
	setSelectedJob(state: any, payload: any) {
		state.commit('setSelectedJob', payload);
	},
	setFilters(state: any, payload: any) {
		state.commit('setFilters', payload);
	},
	setCandidateFilter(state: any, payload: any) {
		state.commit('setCandidateFilter', payload);
	},
	setOrder(state: any, payload: any) {
		state.commit('setOrder', payload);
	},
	setSearch(state: any, payload: any) {
		state.commit('setSearch', payload);
	},
};
